module.exports = __webpack_public_path__ + "assets/img/loading.cdae69e2.gif";